const contentRequests = [
	{
		path: '/community/content-requests',
		name: 'community-content-requests-list',
		component: () => import('@/views/community/content-requests/index.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,contents',
		},
	},
]

export default contentRequests
